import { ETicketFilter } from '@constants';
import { Badge, Flex } from 'antd';

import { useMyTicketsList } from '@/store';

export const PendingDoubtsBadge = () => {
  const { isLoading, pagination } = useMyTicketsList(ETicketFilter.OPEN);

  if (isLoading) return null;

  return (
    <Flex align="center" justify="center">
      <Badge count={pagination?.totalDocs ?? 0} />
    </Flex>
  );
};
